module.exports = __webpack_public_path__ + "media/images/lp-fukushima12/slider_arrow_l-dd7b6f5c119db9dd05707358f8fe8007.svg";